export default "__VITE_ASSET__BdM6WZs$__"